module.exports = __webpack_public_path__ + "web_static/img/right_white2.9ab4149a.png";